<div *ngIf="isContained && visible" class="filter-sidebar-contained-mask" (click)="onContainedMaskClick()"></div>
<p-sidebar [(visible)]="visible" (visibleChange)="visibleChange.emit($event)" [position]="position"
  (onHide)="onSidebarHidden()"
  [modal]="!isContained" [appendTo]="sidebarAppendTo" [showCloseIcon]="false"
  [styleClass]="isContained ? 'filter-sidebar filter-sidebar-contained' : 'filter-sidebar'" [style]="sidebarStyle">
  <ng-template pTemplate="header">
    <div class="filter-sidebar-header flex align-items-center justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <img src="/assets/images/temp/filters.svg" alt="Filters" class="-ml-1" width="30" height="30" />
        <span class="filter-sidebar-title" translate>{{ title }}</span>
      </div>
      <button pButton type="button" icon="pi pi-times" (click)="closeSidebar()"></button>
    </div>
  </ng-template>

  <div class="filter-sidebar-body">
    <div class="filter-categories" [style.width]="categoryColumnWidth || null">
      <div class="filter-categories-header">
        <div *ngFor="let cat of config" class="filter-category-item flex align-items-center justify-content-between"
          [class.active]="activeFilterCategory === cat.key"
          [class.filter-category-disabled]="cat.disabled"
          (click)="onFilterCategoryClick(cat.key)">
          <span class="filter-category-label">{{ cat.label }}</span>
          <span *ngIf="getSelectedCount(cat.key) > 0" class="text-xs">{{ getSelectedCount(cat.key) }}</span>
        </div>
      </div>
    </div>

    <div class="filter-options-panel">
      <ng-container *ngIf="activeConfig as activeCfg">
        <div *ngIf="!isDateCategory(activeCfg.key)" class="filter-search-wrapper">
          <div *ngIf="isSearchable(activeCfg.key)" class="filter-search-input-wrap">
            <i class="pi pi-search filter-search-icon"></i>
            <input type="text" pInputText class="filter-search-input" [(ngModel)]="filterSearchText"
              [placeholder]="activeCfg.searchPlaceholder || ('Search ' + activeCfg.label)" />
            <i *ngIf="filterSearchText" class="pi pi-times filter-search-clear" (click)="filterSearchText = ''"></i>
          </div>
          <div *ngIf="isMultiSelectCategory(activeCfg.key) && isOptionsPresent(activeCfg.key)"
            class="filter-select-actions flex align-items-center justify-content-between">
            <span class="filter-select-actions-title">{{ activeCfg.label }}</span>
            <div class="filter-select-all flex align-items-center gap-2">
              <span class="filter-select-all-label" (click)="toggleSelectAllOptions(activeCfg.key)">Select All ({{ getFilteredOptions(activeCfg.key).length }})</span>
              <p-checkbox [binary]="true" [ngModel]="areAllFilteredOptionsSelected(activeCfg.key)"
                [disabled]="isCategoryDisabled(activeCfg.key)"
                (onChange)="toggleSelectAllOptions(activeCfg.key)"></p-checkbox>
            </div>
          </div>
        </div>

        <div *ngIf="isDateCategory(activeCfg.key)" class="filter-date-panel">
          <p-calendar [ngModel]="getTempSelections(activeCfg.key)"
            (ngModelChange)="onDateChange(activeCfg.key, $event)"
            [selectionMode]="isDateRangeMode(activeCfg) ? 'range' : 'single'"
            [showIcon]="true" dateFormat="dd/mm/yy" [showButtonBar]="true"
            [placeholder]="activeCfg.searchPlaceholder || 'Select date'"
            [inline]="true" >
          </p-calendar>
        </div>

        <div *ngIf="!isDateCategory(activeCfg.key)" class="filter-options-list">
          <div *ngFor="let option of getFilteredOptions(activeCfg.key); let last = last"
            class="filter-option-item flex align-items-center justify-content-between" [class.no-border]="last"
            [class.filter-option-disabled]="isCategoryDisabled(activeCfg.key)"
            (click)="!isCategoryDisabled(activeCfg.key) && toggleFilterOption(activeCfg.key, option.value)">
            <span class="filter-option-label">{{ option.label }}</span>
            <p-radioButton *ngIf="isSingleSelectCategory(activeCfg.key)" [value]="option.value"
              [ngModel]="getTempSelections(activeCfg.key)" [disabled]="isCategoryDisabled(activeCfg.key)"
              (click)="$event.stopPropagation()"
              (onClick)="toggleFilterOption(activeCfg.key, option.value)"></p-radioButton>
            <p-checkbox *ngIf="isMultiSelectCategory(activeCfg.key)" [binary]="true"
              [ngModel]="isFilterOptionSelected(activeCfg.key, option.value)"
              [disabled]="isCategoryDisabled(activeCfg.key)" (click)="$event.stopPropagation()"
              (onChange)="toggleFilterOption(activeCfg.key, option.value)"></p-checkbox>
          </div>
          <div *ngIf="getFilteredOptions(activeCfg.key).length === 0" class="filter-no-results">
            No options found
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="filter-sidebar-footer flex align-items-center justify-content-end w-full gap-3">
      <span class="filter-clear-all" (click)="onFilterClearAll()">Clear all</span>
      <button pButton type="button" label="Apply" class="p-button-primary filter-apply-btn"
        (click)="onFilterApply()"></button>
    </div>
  </ng-template>
</p-sidebar>
